import React from "react";
import BulkUploadFile from "../../components/BulkUploadFile";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as BulkUploadEvInventoryActions from "../../store/actions/BulkUploadEvInventory";

const instructions = [
  "Please provide data as per the format in the sample file.",
  "The sample CSV file should only be opened/edited with MS Excel or Google Sheets, and not with any other text editors.",
];

const BulkUploadEvInventoryDashboard = ({ getBulkUploadUrl }) => {
  return (
    <BulkUploadFile
      instructions={instructions}
      btnDataTestID="BulkUploadInventoryBtn"
      uploadUrl="/bulk-upsert-ev-inventory/ack"
      sampleURL="/sample/bulk_upload_ev_inventory.csv"
      id="BulkUploadEvInventoryModal"
      sendExtraAck={true}
      keyName="callback_key"
      heading="Bulk Upload Ev Inventory"
      getUploadUrl={getBulkUploadUrl}
    />
  );
};

function mapDispatchToProps(dispatch) {
  return {
    getBulkUploadUrl: bindActionCreators(
      BulkUploadEvInventoryActions.getUploadUrl,
      dispatch
    ),
  };
}

export default connect(
  null,
  mapDispatchToProps
)(BulkUploadEvInventoryDashboard);
